module.exports = __webpack_public_path__ + "img/w1_6.8bd0a651.png";